
export const openExportDialog = () => {
    return {type: "OPEN_EXPORT_DIALOG"};
};

export function closeExportDialog(range) {
    return {type: "CLOSE_EXPORT_DIALOG", range: range};
}

export function cancelExportDialog() {
    return {type: "CANCEL_EXPORT_DIALOG"};
}




// WEBPACK FOOTER //
// ./src/store/actions/fileexport.js